import { buildQueries, HTTP } from "@/api/http-common";
import ENDPOINT from "@/api/endpoints";

export function callApiGetLoaiLichLamViec(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.LICH_LAM_VIEC.GET_TAT_CA_LOAI_LICH_LAM_VIEC}?${buildQueries(
        payload
      )}`
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiTaoLichLamViec(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.LICH_LAM_VIEC.TAO_LICH_LAM_VIEC, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayLichLamViec(id) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.LICH_LAM_VIEC.TAO_LICH_LAM_VIEC}/${id}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiCapNhatLichLamViec(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.put(ENDPOINT.LICH_LAM_VIEC.CAP_NHAT_LICH_LAM_VIEC, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiGetChiTietLichLamViec(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.LICH_LAM_VIEC.GET_CHI_TIET_LICH_LAM_VIEC}?${buildQueries(
        payload
      )}`
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiXoaLichLamViec(id, endpoint) {
  return new Promise((resolve, reject) => {
    return HTTP.delete(endpoint + id)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiGetCanBo(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.CAN_BO.GET_ALL}?${buildQueries(payload)}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiGetDanhSanhLichLamViec(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.LICH_LAM_VIEC.GET_DANH_SACH_LICH_LAM_VIEC}?${buildQueries(
        payload
      )}`
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApisuaLichLamViec(payload, endpoint) {
  return new Promise((resolve, reject) => {
    return HTTP.put(endpoint, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiInLichLamViec(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.LICH_LAM_VIEC.XUAT_LICH_LAM_VIEC}?${buildQueries(payload)}`,
      { responseType: "blob" }
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachTheoLoaiLichCha(payload) {
    return HTTP({
        url: ENDPOINT.LICH_LAM_VIEC.CHILDREN,
        method: "GET",
        params: payload
    });
}

export function callApiLayCayDonVi(payload) {
    return HTTP({
        url: ENDPOINT.LICH_LAM_VIEC.TREE,
        method: "GET",
        params: payload
    });
}

export function callApiGetChiTietLoaiLichLamViec(payload) {
    return new Promise((resolve, reject) => {
        return HTTP.get(
            `${ENDPOINT.LICH_LAM_VIEC.GET_CHI_TIET_LOAI_LICH_LAM_VIEC}?${buildQueries(
                payload
            )}`
        )
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}